import useAccountQuery from "@/shared/hooks/useAccountQuery";
import { voteMockPoll } from "@/shared/queries/polls/mock/pollVotesMock";
import { generalToastId } from "@/shared/utils/constant";
import { errorToast } from "@/shared/utils/helpers";
import { AppsmenError } from "@/shared/utils/interfaces";
import { useMutation, useQueryClient } from "@tanstack/react-query";

const usePollVotePost = () => {
  const queryClient = useQueryClient();
  const { data: account } = useAccountQuery();

  return useMutation<void, AppsmenError, { pollId: number; optionIds: number[] }>({
    // TODO: replace with the real endpoint once it exists, e.g.
    // post2(`internal/secure/pos/v1/polls/${pollId}/votes`, { option_ids: optionIds })
    mutationFn: ({ pollId, optionIds }) =>
      voteMockPoll(pollId, optionIds, account?.item_id),
    onSettled: (_, __, { pollId }) => {
      queryClient.invalidateQueries({ queryKey: ["pollResults", pollId] });
      queryClient.invalidateQueries({ queryKey: ["pollResultsSummary", pollId] });
      queryClient.invalidateQueries({ queryKey: ["pollResponses", pollId] });
    },
    onError: () => {
      errorToast("pollVote.voteFailed", generalToastId);
    },
  });
};

export default usePollVotePost;
